import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import Header from '../components/header/Header'
import Footer from '../components/footer/Footer'
import img1 from '../assets/images/box-item/card-item-10.jpg'
import img2 from '../assets/images/box-item/image-box-10.jpg'
import img3 from '../assets/images/box-item/image-box-11.jpg'
import img4 from '../assets/images/box-item/image-box-21.jpg'
import img5 from '../assets/images/box-item/image-box-6.jpg'

const Activity01 = () => {
    const [dataBox] = useState([
        {
            img: img1,
            title: "★ Sport Gloves | Pandora's Box",
            status: 'Confirming',
            time: '2:30 PM on 19th June, 2021',
            tags: 'Minimal Wear',
            price: '100,000 VNĐ',
            item_float: '0.07874',
            discount: 30,
            phase: 'Phase 1',
            icon: 'icon-1',
        },
        {
            img: img2,
            title: 'AWP | Dragon Lore',
            status: 'Waiting for payment',
            tags: 'Minimal Wear',
            price: '100,000 VNĐ',
            item_float: '0.07874',
            discount: 30,
            phase: 'Phase 1',
            time: '2:30 PM on 19th June, 2021',
            icon: 'icon-2',
        },
        {
            img: img3,
            title: 'AWP | Gungnir',
            status: 'Paid',
            tags: 'Minimal Wear',
            price: '100,000 VNĐ',
            item_float: '0.07874',
            discount: 30,
            phase: 'Phase 1',
            time: '2:30 PM on 19th June, 2021',
            icon: 'icon-3',
        },
        {
            img: img1,
            title: "★ Sport Gloves | Pandora's Box",
            status: 'Delivered',
            tags: 'Minimal Wear',
            price: '100,000 VNĐ',
            item_float: '0.07874',
            discount: 30,
            phase: 'Phase 1',
            time: '2:30 PM on 19th June, 2021',
            icon: 'icon-1',
        },
        {
            img: img2,
            title: 'AWP | Dragon Lore',
            status: 'Delivered',
            tags: 'Minimal Wear',
            price: '100,000 VNĐ',
            item_float: '0.07874',
            discount: 30,
            phase: 'Phase 1',
            time: '2:30 PM on 19th June, 2021',
            icon: 'icon-2',
        },
        {
            img: img3,
            title: 'AWP | Gungnir',
            status: 'Canceled',
            tags: 'Minimal Wear',
            price: '100,000 VNĐ',
            item_float: '0.07874',
            discount: 30,
            phase: 'Phase 1',
            time: '2:30 PM on 19th June, 2021',
            icon: 'icon-3',
        },
        {
            img: img1,
            title: "★ Sport Gloves | Pandora's Box",
            status: 'Delivered',
            tags: 'Minimal Wear',
            price: '100,000 VNĐ',
            item_float: '0.07874',
            discount: 30,
            phase: 'Phase 1',
            time: '2:30 PM on 19th June, 2021',
            icon: 'icon-1',
        },
        {
            img: img2,
            title: 'AWP | Dragon Lore',
            status: 'Canceled',
            tags: 'Minimal Wear',
            price: '100,000 VNĐ',
            item_float: '0.07874',
            discount: 30,
            phase: 'Phase 1',
            time: '2:30 PM on 19th June, 2021',
            icon: 'icon-2',
        },
        {
            img: img3,
            title: 'AWP | Gungnir',
            status: 'Delivered',
            tags: 'Minimal Wear',
            price: '100,000 VNĐ',
            item_float: '0.07874',
            discount: 30,
            phase: 'Phase 1',
            time: '2:30 PM on 19th June, 2021',
            icon: 'icon-3',
        },
    ])
    const [dataFilter] = useState([
        {
            icon: 'icon-fl-sort-filled',
            name: 'Confirming',
        },
        {
            icon: 'icon-fl-heart-filled',
            name: 'Waiting for payment',
        },
        {
            icon: 'icon-fl-buy',
            name: 'Paid',
        },
        {
            icon: 'icon-fl-discount',
            name: 'Delivered',
        },
        {
            icon: 'icon-fl-logout',
            name: 'Canceled',
        },
    ])

    const [visible, setVisible] = useState(5)
    const showMoreItems = () => {
        setVisible((prevValue) => prevValue + 5)
    }
    return (
        <div>
            <Header />

            <section className="tf-activity s1 tf-section">
                <div className="themesflat-container">
                    <div className="row">
                        <div className="col-lg-8 col-md-8 col-12">
                            {dataBox.slice(0, visible).map((item, index) => (
                                <div className="sc-card-activity style1" key={index}>
                                    <div className="content">
                                        <div className="media">
                                            <img src={item.img} alt="Axies" />
                                        </div>
                                        <div className="infor">
                                            <h3>
                                                {' '}
                                                <Link to="/item-details-02">{item.title}</Link>
                                            </h3>
                                            <div className="status">
                                                Status <span className="author">{item.status}</span>
                                            </div>
                                            <div className="status">
                                                Info{' '}
                                                <span className="author">
                                                    {item.tags} - {item.item_float} - {item.phase}
                                                </span>
                                            </div>
                                            <div className="status">
                                                Price <span className="author">{item.price}</span>
                                            </div>
                                            <div className="time">Buy at {item.time}</div>
                                        </div>
                                    </div>
                                    <div className={`button-active icon ${item.icon}`}></div>
                                </div>
                            ))}
                            {visible < dataBox.length && (
                                <div className="col-md-12 wrap-inner load-more text-center">
                                    <Link
                                        to="#"
                                        id="load-more"
                                        className="sc-button loadmore fl-button pri-3 mt-10"
                                        onClick={showMoreItems}
                                    >
                                        <span>Load More</span>
                                    </Link>
                                </div>
                            )}
                        </div>
                        <div className="col-lg-4 col-md-4 col-12">
                            <div id="side-bar" className="side-bar style-2">
                                <div className="widget widget-search mgbt-24">
                                    <form action="#">
                                        <input type="text" placeholder="Search item..." required />
                                        <button>
                                            <i className="icon-fl-search-filled"></i>
                                        </button>
                                    </form>
                                </div>

                                <div className="widget widget-filter style-2 mgbt-0">
                                    <h3 className="title-widget">Filter</h3>
                                    <ul className="box-check">
                                        {dataFilter.map((item, index) => (
                                            <li key={index}>
                                                <Link to="#" className="box-widget-filter">
                                                    <i className={item.icon}></i>
                                                    {item.name}
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                    <Link to="#" className="clear-check btn-filter style-2">
                                        Clear All Filters
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default Activity01
